import { useTheme } from "@emotion/react";
import React from "react";
import { IconType } from "react-icons/lib";

import { Tile } from "./Tile";

type Props = {
  label: string;
  value: string;
  Icon?: IconType;
  onClick?: () => void;
  href?: string;
  className?: string;
  isActive?: boolean;
  actions?: React.ReactNode;
};

export const TileCard: React.FC<Props> = ({ Icon, label, value, onClick, href, className, isActive, actions }) => {
  const theme = useTheme();

  return (
    <Tile
      href={href}
      onClick={onClick}
      className={className}
      stripe={
        Icon ? (
          <div
            css={{
              color: isActive ? "white" : theme.colors.primary,
              background: isActive ? theme.colors.primary : "transparent",
              opacity: isActive ? 1 : 0.1,
              padding: "0.5rem 0.875rem",
              minHeight: 0,
              alignSelf: "stretch",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRight: `1px solid ${isActive ? theme.colors.primary : "rgba(0, 0, 0)"}`,
            }}
          >
            <Icon size={18} />
          </div>
        ) : undefined
      }
    >
      <div css={{ display: "flex", alignItems: "center", gap: "0.5rem", justifyContent: "space-between" }}>
        <div css={{ display: "flex", flexDirection: "column" }}>
          <span css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>{label}</span>
          <span
            css={{
              fontSize: "0.875rem",
              color: isActive ? theme.colors.primary : theme.colors.secondaryText,
              fontWeight: isActive ? 700 : 400,
              opacity: isActive ? 1 : 0.5,
            }}
          >
            {value}
          </span>
        </div>
        {actions && <div css={{ display: "flex", alignItems: "center" }}>{actions}</div>}
      </div>
    </Tile>
  );
};
